import React from 'react'
import PropTypes from 'prop-types'

const Row = (props) => (
  <div className={'row' + (props.classes !== undefined && props.classes.length > 0 ? ' ' + props.classes.join(' ') : '')}>
    {props.children}
  </div>
)

Row.propTypes = {
  classes: PropTypes.array,
  children: PropTypes.node
}

const Content = (props) => (
  <div className={'content' + (props.classes !== undefined && props.classes.length > 0 ? ' ' + props.classes.join(' ') : '')} id={(props.id !== undefined ? props.id : '')}>
    {props.children}
  </div>
)

Content.propTypes = {
  id: PropTypes.string,
  classes: PropTypes.array,
  children: PropTypes.node
}

export {
  Row,
  Content
}



// WEBPACK FOOTER //
// ./src/components/Layout.js